import '../scss/pfields/Pcheckbox.scoped.scss';
import {useState} from "react";

function Pcheckbox({pfield, id}) {
  let tol = pfield.obj.querySelector("input");
  const [value, setValue] = useState(tol.value);
  const [isChecked, setIsChecked] = useState(tol.checked);
  let sid = "r" + id;
  let lol = pfield.label;
  const updatePardot = (e) => {
    let f = e.target;
    let o = [...document.querySelectorAll("#p-content input[type='checkbox']")]
      .filter(
        (c) => c.name === f.name.substring(1)
      )[0];
    if(o) {
      o.checked = f.checked;
    } else {
      console.log(">>> " + f.name);
    }
    setIsChecked(f.checked);
  }
  return(
    <div className="rcheckbox">
      <input 
        type="checkbox" 
        id={sid} 
        name={sid} 
        value={value} 
        checked={isChecked} 
        onChange={updatePardot} />
      <label htmlFor={sid}>{lol}</label>
    </div>
  );

}
export default Pcheckbox;